import { useMemo } from 'react';

import { Select, SelectProps } from '@mantine/core';
import { capitalize } from '@utils/strings';

import { useGetNationsQuery } from '@api/locations.api';

export default function NationSelector(props: SelectProps) {
  const { data = [], isLoading } = useGetNationsQuery(undefined, {
    skip: props.disabled,
  });

  const nations = useMemo(() => {
    const nationsSet = new Set(data.map((nation) => capitalize(nation.nome)));

    return Array.from(nationsSet)
      .toSorted((a, b) => (a > b ? 1 : -1))
      .map((nation) => ({
        value: nation,
        label: nation,
      }));
  }, [data]);

  return (
    <Select
      label="Nazione"
      placeholder="Seleziona nazione"
      data={nations}
      searchable
      {...props}
      disabled={isLoading || props.disabled}
    />
  );
}
